module.exports = __webpack_public_path__ + "img/connect_step1_m.f42116df.png";